import { render, staticRenderFns } from "./payroll-sheet-detail.vue?vue&type=template&id=5e56275a&scoped=true&"
import script from "./payroll-sheet-detail.vue?vue&type=script&lang=js&"
export * from "./payroll-sheet-detail.vue?vue&type=script&lang=js&"
import style0 from "./payroll-sheet-detail.vue?vue&type=style&index=0&id=5e56275a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56275a",
  null
  
)

export default component.exports